const getters = {
  proxies: (state) => state.proxies,
  settings: (state) => state.settings,
};

export default getters;
